import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    dateAndMonth, formatTimeWithoutTimezone, getDayName, getTimezoneDiffName,
} from '../../../../../utils';
import { getActiveTimeslotId, getSelectedDate } from '../../../../store/selectors';
import {
    selectDoctor,
    setActiveTimeslotId,
    setBookingError,
    setSelectedSlotDuration,
} from '../../../../store/serviceSlice';

const doctorItem = require('b_')
    .with('doctor-item');

const sortTimeslots = ({ startTime: a }, { startTime: b }) => {
    return new Date(a?.trim?.()
        .split(' ')
        .join('T')).getTime() - new Date(b?.trim?.()
        .split(' ')
        .join('T')).getTime();
};

export const TimeDiff = ({ isBold = true }) => {
    const text = getTimezoneDiffName();
    return text ? <span className={doctorItem('diff', { bold: isBold })}> ({text})</span> : null;
};

export const TimeslotList = ({
    timeslots,
    doctorId = [],
    slotDuration,
    collapsed,
}) => {
    const [ isTimeslotsVisible, toggleTimeslotsVisibility ] = useState(false);
    const dispatch = useDispatch();
    const activeTimeslotId = useSelector(getActiveTimeslotId);

    const date = useSelector(getSelectedDate);

    useEffect(() => {
        toggleTimeslotsVisibility(false);
    }, [collapsed]);
    const onTimeslot = (id) => {
        dispatch(selectDoctor(doctorId));
        dispatch(setActiveTimeslotId(id));
        dispatch(setSelectedSlotDuration(slotDuration));
        dispatch(setBookingError(''));
    };
    return (
        timeslots?.length ? (
            <div className={doctorItem('timeslots-container')}>
                <span className={doctorItem('desc', { 'nearest-date': true })}>{`${dateAndMonth(
                    date,
                )} - ${getDayName(date)}`}<TimeDiff/></span>
                <ul className={doctorItem('timeslots', { 'is-opened': isTimeslotsVisible })}>
                    {[...timeslots].sort(sortTimeslots)
                        .map(({
                            startTime,
                            timeslotId,
                        }) => (
                            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                            <li
                                key={timeslotId}
                                className={doctorItem('timeslot', { active: +activeTimeslotId === +timeslotId })}
                                onClick={() => onTimeslot(timeslotId)}>
                                {formatTimeWithoutTimezone(startTime)}
                            </li>
                        ))}
                </ul>
                {timeslots.length <= 5 ? null : (
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                    <a
                        className={doctorItem('timeslots-toggler', { rotate: isTimeslotsVisible })}
                        onClick={() => toggleTimeslotsVisibility(prevState => !prevState)}>
                        {`Показать ${isTimeslotsVisible ? 'меньше' : 'больше'} таймслотов для записи`}
                    </a>
                )}
            </div>

        ) : null
    );
};
